import getLoginType from "./loginConfig";

const entities = {
  routesToIgnore: [
    {
      path: /^\/entidades\/login/,
      regex: true,
    },
  ],
};

const lcci = {
  getValidRoute: (userInfo) => {
    if (userInfo.lcci_redirect_to_finish) return "/lcci/final/";
  },
  routesToValidate: [
    {
      path: "/lcci",
    },
    {
      path: "/lcci/ficha-de-datos",
    },
  ],
  routesToIgnore: [
    {
      path: /^\/lcci\/login/,
      regex: true,
    },
  ],
};

const test = {
  getValidRoute: (userInfo) => {
    if (userInfo && userInfo.lcci_redirect_to_finish) return "/mis-examenes";
    if (userInfo && userInfo.preinscription) return "/nueva-inscripcion";
  },
  routesToValidate: [
    {
      path: "/",
    },
    {
      path: "/nueva-inscripcion",
    },
  ],
  routesToIgnore: [
    {
      path: /^\/login/,
      regex: true,
    },
  ],
};

export const routesConfig = { entities, lcci, test };

const getValidRoute = (currentPath, userInfo = {}, options = {}) => {
  const { checkValid = true, checkIgnore = false } = options;
  const loginType = getLoginType();
  const routeConfig = routesConfig[loginType.name];
  //   const routeConfig = routesConfig.test;
  if (!routeConfig.getValidRoute) return null;
  const routeByData = routeConfig.getValidRoute(userInfo || {});
  if (!routeByData || currentPath === routeByData) return null;
  const founded = routeConfig[
    checkIgnore ? "routesToIgnore" : "routesToValidate"
  ].find((item) => {
    if (item.regex) return item.path.test(currentPath);
    return currentPath === item.path || currentPath === item.path + "/";
  });
  if (checkIgnore) return founded ? null : routeByData;
  if (checkValid) return founded ? routeByData : null;
};

export default getValidRoute;
